export default __webpack_public_path__ + "static/media/chayene-banta.53338373.png";